<div class="financial-review">
  <form [formGroup]="financialReviewForm">
    <div class="mb-5 font-medium">Performance Analysis</div>
    <div class="financial-review-section">
      <div class="subheader">#1 Past Performance</div>
      <div class="section-form">
        <p class="my-2">Past performance is calculated by averaging the two largest public works, then multiply by 0.33 if under $10m or 0.5 if over $10m.</p>
        <div class="flex">
          <mat-form-field class="w-64">
            <mat-label>Largest PW</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="largestPublicWork" name="largestPublicWork" [placeholder]="'$'" readonly />
          </mat-form-field>
          <span class="w-10 pt-2 text-lg text-center">+</span>
          <mat-form-field class="w-64">
            <mat-label>2nd Largest PW</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="secondLargestPublicWork" name="secondLargestPublicWork" [placeholder]="'$'" readonly />
          </mat-form-field>
          <span class="w-10 pt-2 text-lg text-center">=</span>
          <mat-form-field class="w-64">
            <mat-label>AVG 2 Largest PW</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="averageLargestPublicWork" name="averageLargestPublicWork" [placeholder]="'$'" readonly />
          </mat-form-field>
        </div>
        <div class="flex">
          <mat-form-field class="w-64">
            <mat-label>AVG PW with Multiplier</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="averageLargestPublicWorkWithMultiplier" name="averageLargestPublicWorkWithMultiplier" [placeholder]="'$'" readonly />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="financial-review-section">
      <div class="subheader">#2 Financial Review</div>
      <div class="section-form">
        <p class="my-2">The financial review calculates the working capital and net worth and multiplies by 8.</p>
        <div class="flex">
          <mat-form-field class="w-64">
            <mat-label>Current Assets</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="currentAssets" name="currentAssets" placeholder="$" />
          </mat-form-field>
          <span class="w-10 pt-2 text-xl text-center">-</span>
          <mat-form-field class="w-64">
            <mat-label>Current Liabilities</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="currentLiabilities" name="currentLiabilities" [placeholder]="'$'" />
          </mat-form-field>
          <span class="w-10 pt-2 text-lg text-center">=</span>
          <mat-form-field class="w-64">
            <mat-label>Working Capital (8x)</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="workingCapital" name="workingCapital" [placeholder]="'$'" readonly />
          </mat-form-field>
        </div>
        <p class="my-2">The current ratio indicates the company's ability to pay off short term debts using its assets. A good threshold value for the current ratio is >=1.</p>
        <div class="flex">
          <mat-form-field class="w-64">
            <mat-label>Current Assets</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="secondCurrentAssets" name="secondCurrentAssets" [placeholder]="'$'" />
          </mat-form-field>
          <span class="w-10 pt-2 text-lg text-center">/</span>
          <mat-form-field class="w-64">
            <mat-label>Current Liabilities</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="secondCurrentLiabilities" name="secondCurrentLiabilities" [placeholder]="'$'" />
          </mat-form-field>
          <span class="w-10 pt-2 text-lg text-center">=</span>
          <mat-form-field class="w-64">
            <mat-label>Current Ratio</mat-label>
            <input matInput type="text" class="form-control" formControlName="currentRatio" name="currentRatio" readonly />
          </mat-form-field>
        </div>
        <div class="flex">
          <mat-form-field class="w-64">
            <mat-label>Total Assets</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="totalAssets" name="totalAssets" [placeholder]="'$'" (keyup)="calculateTotals()" />
          </mat-form-field>
          <span class="w-10 pt-2 text-xl text-center">-</span>
          <mat-form-field class="w-64">
            <mat-label>Total Liabilities</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="totalLiabilities" name="totalLiabilities" [placeholder]="'$'" (keyup)="calculateTotals()" />
          </mat-form-field>
          <span class="w-10 pt-2 text-lg text-center">=</span>
          <mat-form-field class="w-64">
            <mat-label>Net Worth (8x)</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="netWorth" name="netWorth" [placeholder]="'$'" readonly />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="financial-review-section">
      <div class="subheader">#3 Bonding Capacity</div>
      <div class="section-form">
        <p class="my-2">Bonding capacity - single project</p>
        <div>
          <mat-form-field class="w-64">
            <mat-label>Bonding Capacity</mat-label>
            <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [allowNegativeNumbers]="false" separatorLimit="100000000000" type="text" class="form-control" formControlName="bondCapacity" name="bondCapacity" [placeholder]="'$'" readonly />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-6/12">
            <mat-label>Rating Analysis Notes</mat-label>
            <textarea matInput type="text" class="form-control" formControlName="ratingAnalysisNotes" name="ratingAnalysisNotes"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="flex financial-review-section">
      <div class="flex-1">
        <mat-checkbox formControlName="financialReviewConfirmed">Financial Review Confirmed</mat-checkbox>
      </div>
      @if (!disabled) {
        <div class="flex-0">
          <button [disabled]="saving" mat-raised-button color="primary" (click)="onSaveClick()" class="mr-2">Save Financials</button>
          <button [disabled]="saving" mat-button (click)="onCancel(cancelModal)">Cancel</button>
        </div>
      }
    </div>
  </form>
</div>

<qb-modal #cancelModal>
  <div modal-header>Confirm Changes</div>
  <p>Are you sure you'd like to undo any changes you have made to the Rating Analysis section of this application?</p>
  <div modal-buttons>
    <button mat-raised-button color="primary" type="button" (click)="confirmReset(cancelModal)">Undo Changes</button>
  </div>
</qb-modal>
